export const semanticTokens = {
  colors: {
    warning: 'orange.500',
  },
}
